import React from 'react';
import { PERSONAL } from '../data/portfolio';

export default function Footer({ isDark }) {
  return (
    <footer
      className={`py-8 border-t ${
        isDark
          ? 'bg-navy-900 border-navy-400/40'
          : 'bg-white border-gray-200'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className={`font-mono text-xs ${isDark ? 'text-gray-600' : 'text-gray-400'}`}>
          Built with{' '}
          <span style={{ color: 'var(--gold)' }}>♥</span> by{' '}
          <span className={isDark ? 'text-gray-400' : 'text-gray-600'}>
            {PERSONAL.name}
          </span>{' '}
          · Senior Java Developer · {PERSONAL.location}
        </p>
        <p className={`font-mono text-xs ${isDark ? 'text-gray-700' : 'text-gray-400'}`}>
          React · Framer Motion · Tailwind CSS &nbsp;·&nbsp;
          <span style={{ color: 'var(--gold)' }}>Deploy on Vercel / EC2</span>
        </p>
      </div>
    </footer>
  );
}
